import { Option } from "@inrev/core";
import type { ComputeActionItemsInput } from "./computeActionItems";
import type { ActionItem } from "./types";

const indemnityCopy = {
	pending: {
		title: "Indemnity Pending Signature",
		description: "All required indemnitors must sign the agreement before bonds can be issued.",
	},
	review: {
		title: "Indemnity Under Review",
		description:
			"An underwriter is reviewing the uploaded indemnity agreement. Once approved, bonds can be issued.",
	},
	missing: {
		title: "Indemnity Agreement Required",
		description: "Create an indemnity agreement for required indemnitors to sign.",
	},
} as const;

export function isApprovedOrActive(status: ComputeActionItemsInput["account"]["status"]): boolean {
	return status === "approved" || status === "active";
}

export function computeIndemnityItems({
	account,
	latestIndemnityAgreement,
}: ComputeActionItemsInput): ActionItem[] {
	if (Option.isSome(latestIndemnityAgreement) && latestIndemnityAgreement.status === "pending") {
		const config = indemnityCopy[latestIndemnityAgreement.status];
		return [
			{
				key: `indemnity-${latestIndemnityAgreement.status}`,
				severity: "warn",
				label: config.title,
				reason: config.description,
				action: { type: "navigate", navigate: { tabId: "indemnity" } },
				actionLabel: "View Indemnity",
			},
		];
	}

	if (Option.isSome(latestIndemnityAgreement) && latestIndemnityAgreement.status === "review") {
		const config = indemnityCopy[latestIndemnityAgreement.status];
		return [
			{
				key: `indemnity-${latestIndemnityAgreement.status}`,
				severity: "info",
				label: config.title,
				reason: config.description,
				actionLabel: "No Action Required",
			},
		];
	}

	if (isApprovedOrActive(account.status) && Option.isNone(latestIndemnityAgreement)) {
		const config = indemnityCopy.missing;
		return [
			{
				key: "indemnity-missing",
				severity: "warn",
				label: config.title,
				reason: config.description,
				action: { type: "navigate", navigate: { tabId: "indemnity" } },
				actionLabel: "View Indemnity",
			},
		];
	}

	return [];
}
